var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 44,
    style: {
      fill: "#9C6152"
    },
    width: 48,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B28376"
    },
    d: "M10,55c0,2.209,1.791,4,4,4h42V44H10V55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0322F"
    },
    d: "M45,34c-1.105,0-2,0.895-2,2v4h4v-4C47,34.895,46.105,34,45,34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D83B3E"
    },
    d: "M47,36c0-1.105-0.895-2-2-2c-0.276,0-0.539,0.056-0.778,0.157C44.082,34.449,44,34.772,44,35.107V37 c0,1.105,0.895,2,2,2h1V36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6B25E"
    },
    d: "M52,34c-1.105,0-2,0.895-2,2v4h4v-4C54,34.895,53.105,34,52,34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D16E"
    },
    d: "M54,36c0-1.105-0.895-2-2-2c-0.276,0-0.539,0.056-0.778,0.157C51.082,34.449,51,34.772,51,35.107V37 c0,1.105,0.895,2,2,2h1V36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    style: {
      fill: "#EBEBFD"
    },
    width: 4,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F9FE"
    },
    d: "M34,17h-2v18.184c0,1.304,0.837,2.403,2,2.816V17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#469C65"
    },
    points: "32,2 4,17 60,17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#58C17E"
    },
    points: "32,2 19,17 45,17  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6B25E"
    },
    d: "M4,17c0,2.047,0.763,4.011,2.121,5.458l0.012,0.012c1.115,1.188,2.818,1.483,4.229,0.731 c1.031-0.55,2.245-0.55,3.277,0l0.723,0.385c1.031,0.55,2.245,0.55,3.277,0l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0l0.723,0.385 c1.031,0.55,2.245,0.55,3.277,0l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0l0.723,0.385c1.031,0.55,2.245,0.55,3.277,0l0.723-0.385 c1.031-0.55,2.245-0.55,3.277,0l0.723,0.385c1.031,0.55,2.245,0.55,3.277,0l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0l0.723,0.385 c1.031,0.55,2.245,0.55,3.277,0l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0c1.41,0.752,3.114,0.457,4.229-0.731l0.012-0.012 C59.237,21.011,60,19.047,60,17H4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D16E"
    },
    d: "M9.121,20.458l0.012,0.012c1.115,1.188,2.818,1.483,4.229,0.731c1.031-0.55,2.245-0.55,3.277,0 l0.723,0.385c1.031,0.55,2.245,0.55,3.277,0l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0l0.723,0.385c1.031,0.55,2.245,0.55,3.277,0 l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0l0.723,0.385c1.031,0.55,2.245,0.55,3.277,0l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0 l0.723,0.385c1.031,0.55,2.245,0.55,3.277,0l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0l0.723,0.385c1.031,0.55,2.245,0.55,3.277,0 l0.723-0.385c1.031-0.55,2.245-0.55,3.277,0c0.613,0.327,1.28,0.444,1.931,0.388C59.488,20.269,60,18.665,60,17H7.255 C7.582,18.296,8.216,19.493,9.121,20.458z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40,
    style: {
      fill: "#5B382D"
    },
    width: 52,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C6152"
    },
    d: "M10,42h48v-2H8C8,41.105,8.895,42,10,42z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E6B25E"
    },
    cx: 32,
    cy: 53,
    rx: 7,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D16E"
    },
    d: "M32,44c-1.573,0-3.021,0.676-4.19,1.802C27.295,47.056,27,48.483,27,50c0,4.971,3.134,9,7,9 c1.573,0,3.021-0.676,4.19-1.802C38.705,55.944,39,54.517,39,53C39,48.029,35.866,44,32,44z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 36,
    style: {
      fill: "#E6B25E"
    },
    width: 10,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D16E"
    },
    d: "M14,38h6v-2h-8C12,37.105,12.895,38,14,38z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    style: {
      fill: "#B0322F"
    },
    width: 6,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D83B3E"
    },
    d: "M16,34h2v-2h-4C14,33.105,14.895,34,16,34z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58,39h-3v-3c0-1.302-0.839-2.402-2-2.816V31h-2v2.184c-1.161,0.414-2,1.514-2,2.816v3h-1v-3c0-1.302-0.839-2.402-2-2.816 V31h-2v2.184c-1.161,0.414-2,1.514-2,2.816v3h-7V24.02c0.702-0.314,1.48-0.301,2.168,0.064l0.723,0.387 c1.32,0.703,2.898,0.704,4.219-0.001l0.723-0.385c0.742-0.396,1.594-0.396,2.336-0.001l0.723,0.387 c0.66,0.352,1.385,0.527,2.109,0.527s1.449-0.176,2.109-0.528l0.723-0.385c0.742-0.396,1.594-0.396,2.336,0 c1.814,0.969,3.997,0.596,5.44-0.941C60.15,21.499,61,19.317,61,17c0-0.368-0.203-0.707-0.527-0.882l-28-15 c-0.295-0.158-0.65-0.158-0.945,0l-28,15C3.203,16.293,3,16.632,3,17c0,2.317,0.85,4.499,2.403,6.155 c1.431,1.524,3.614,1.897,5.429,0.93c0.742-0.396,1.594-0.396,2.336-0.001l0.723,0.387c1.32,0.703,2.898,0.704,4.219-0.001 l0.723-0.385c0.742-0.396,1.594-0.396,2.336-0.001l0.723,0.387c1.32,0.703,2.898,0.704,4.219-0.001l0.723-0.385 c0.688-0.367,1.466-0.378,2.168-0.066V39h-8v-3c0-0.553-0.447-1-1-1h-1v-3c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v3h-1 c-0.553,0-1,0.447-1,1v3H6c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h1v17c0,0.553,0.447,1,1,1h48c0.553,0,1-0.447,1-1V45h1 c0.553,0,1-0.447,1-1v-4C59,39.447,58.553,39,58,39z M51,36c0-0.552,0.448-1,1-1s1,0.448,1,1v3h-2V36z M44,36c0-0.552,0.448-1,1-1 s1,0.448,1,1v3h-2V36z M7.985,16L27.693,5.442L18.543,16H7.985z M31,4.681V16h-9.81L31,4.681z M33,4.681L42.81,16H33V4.681z  M45.457,16l-9.15-10.558L56.015,16H45.457z M25.891,22.32l-0.723,0.385c-0.742,0.396-1.594,0.396-2.336,0.001l-0.723-0.387 c-1.32-0.703-2.898-0.704-4.219,0.001l-0.723,0.385c-0.742,0.396-1.594,0.396-2.336,0.001l-0.723-0.387 c-1.32-0.703-2.898-0.703-4.219,0c-1.009,0.538-2.226,0.323-3.04-0.545C5.897,20.759,5.295,19.418,5.093,18h53.813 c-0.202,1.419-0.806,2.76-1.769,3.786c-0.802,0.856-2.021,1.073-3.028,0.533c-1.32-0.703-2.898-0.704-4.219,0.001l-0.723,0.385 c-0.742,0.396-1.594,0.396-2.336,0.001l-0.723-0.387c-0.66-0.352-1.385-0.527-2.109-0.527s-1.449,0.176-2.109,0.528l-0.723,0.385 c-0.742,0.396-1.594,0.396-2.336,0.001l-0.723-0.387c-1.32-0.703-2.898-0.704-4.219,0.001l-0.723,0.385 c-0.742,0.396-1.594,0.396-2.336,0.001l-0.723-0.387C28.789,21.616,27.211,21.615,25.891,22.32z M31,24.881 c0.659,0.151,1.341,0.151,2,0V39h-2V24.881z M13,33h4v2h-4V33z M11,37h8v2h-8V37z M27.221,45c-1.749,1.637-2.952,4.139-3.18,7H9 v-7H27.221z M38,53c0,4.411-2.691,8-6,8s-6-3.589-6-8s2.691-8,6-8S38,48.589,38,53z M9,61v-7h15.041 c0.228,2.861,1.431,5.363,3.18,7H9z M36.779,61c1.749-1.637,2.952-4.139,3.18-7H55v7H36.779z M55,52H39.959 c-0.228-2.861-1.431-5.363-3.18-7H55V52z M57,43H7v-2h50V43z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.50e42314f2c310c83674672fc1236ac5.svg";
export { ForwardRef as ReactComponent };